export default function Stats({ items, onClearItems }) {
  const numItems = items.length;

  if (numItems === 0)
    return (
      <footer className="stats">
        <em>Add some items to your packing list 🚀</em>
      </footer>
    );

  const numPacked = items.filter((item) => item.packed).length;
  const percentage = Math.round((numPacked / numItems) * 100);

  return (
    <footer className="stats">
      <p>
        {percentage === 100
          ? "You got everything! 🎉"
          : `You have ${numItems} items, packed ${numPacked} (${percentage}%)`}
      </p>
      <button onClick={onClearItems}>Clear List</button>
    </footer>
  );
}
